import React from 'react';
import ReactDOM from 'react-dom/client';

import ErrorBoundary from './components/common/ErrorBoundary';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

if (process.env.REACT_APP_TARGET === 'packing') {
  // eslint-disable-next-line import/extensions
  import('./PackingRouter').then(({ default: PackingRouter }) => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <PackingRouter />
        </ErrorBoundary>
      </React.StrictMode>
    );
  });
} else {
  // eslint-disable-next-line import/extensions
  import('./Router').then(({ default: Router }) => {
    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <Router />
        </ErrorBoundary>
      </React.StrictMode>
    );
  });
}

reportWebVitals();
